import { useEffect, useState, useMemo } from 'react';
import { useRouter } from 'next/router';
import CTASection from "@/components/sections/CTASection";
import Challenges from '@/components/SolutionsTemplate/Challenges';
import KeyBenefits from '@/components/SolutionsTemplate/KeyBenefits';
import SeeItInAction from '@/components/SolutionsTemplate/SeeItInAction';
import LandingElement from '@/components/SolutionsTemplate/LandingElement';
import FeaturedUseCases from '@/components/SolutionsTemplate/FeaturedUseCases';

// content jsons
import json_retail_en from "@/components/jsons/solutionsTemplate/retailEn.json";
import json_retail_pt from "@/components/jsons/solutionsTemplate/retailPt.json";
import json_retail_br from "@/components/jsons/solutionsTemplate/retailBr.json";
import json_industries_en from "@/components/jsons/solutionsTemplate/industriesEn.json";
import json_industries_pt from "@/components/jsons/solutionsTemplate/industriesPt.json";
import json_industries_br from "@/components/jsons/solutionsTemplate/industriesBr.json";
import json_transportation_en from "@/components/jsons/solutionsTemplate/transportationEn.json";
import json_transportation_pt from "@/components/jsons/solutionsTemplate/transportationPt.json";
import json_transportation_br from "@/components/jsons/solutionsTemplate/transportationBr.json";

interface SolutionTemplateProps {
    type: string
}

export default function SolutionTemplate({
    type,
}: SolutionTemplateProps) {

    const { locale } = useRouter();

    const jsonData: any = useMemo(() => {
        switch (type) {
            case "retail":
                if (locale === 'br') return json_retail_br;
                if (locale === 'pt') return json_retail_pt;
                return json_retail_en;
            case "transportation":
                if (locale === 'br') return json_transportation_br;
                if (locale === 'pt') return json_transportation_pt;
                return json_transportation_en;
            case "industries":
                if (locale === 'br') return json_industries_br;
                if (locale === 'pt') return json_industries_pt;
                return json_industries_en;
            default:
                return json_retail_en;
        }
    }, [type, locale]);

    useEffect(() => {
        const updateCursor = ({ x, y }: any) => {
            document.documentElement.style.setProperty("--x", x);
            document.documentElement.style.setProperty("--y", y);
        };

        document.body.addEventListener("pointermove", updateCursor);
        return () => document.body.removeEventListener("pointermove", updateCursor);
    }, []);

    const separatorHeight = 100

    return (
        <>
            <div style={{ overflow: "hidden" }}>
                <LandingElement
                    type={type}
                    jsonData={jsonData} />
            </div>

            <div className={"separator"} style={{ "height": separatorHeight + "px" }} />
            <Challenges type={type} jsonData={jsonData.challenges} />
            <div className={"separator"} style={{ "height": separatorHeight + "px" }} />
            <FeaturedUseCases type={type} jsonData={jsonData.featuredUseCases} />
            <div className={"separator"} style={{ "height": separatorHeight + "px" }} />
            <KeyBenefits type={type} jsonData={jsonData.keyBenefits} />
            <div className={"separator"} style={{ "height": separatorHeight + "px" }} />
            <SeeItInAction type={type} jsonData={jsonData.seeItInAction} />
            <CTASection />
        </>
    )
}